import React from 'react';
import Page from "../common/Page";
import { UilBill } from "@iconscout/react-unicons";
import { Table } from "react-bulma-components";
import { Link } from "react-router-dom";

export default function BillsPage({}) {
    const bills = [
        {
            id: 1,
            name: 'Electricity',
            date: '2022-02-03',
            total: 85.24,
            isPaid: true,
            home: {
                id: 1,
                name: 'Barley Farm'
            }
        },
        {
            id: 3,
            name: 'Internet',
            date: '2022-02-01',
            total: 49.99,
            isPaid: true,
            home: {
                id: 1,
                name: 'Barley Farm'
            }
        },
        {
            id: 4,
            name: 'Electricity',
            date: '2022-01-05',
            total: 82.96,
            isPaid: true,
            home: {
                id: 1,
                name: 'Barley Farm'
            }
        },
        {
            id: 5,
            name: 'Gas',
            date: '2022-01-05',
            total: 77.23,
            isPaid: false,
            home: {
                id: 1,
                name: 'Barley Farm'
            }
        },
        {
            id: 6,
            name: 'Internet',
            date: '2022-01-01',
            total: 49.99,
            isPaid: true,
            home: {
                id: 1,
                name: 'Barley Farm'
            }
        },
        {
            id: 7,
            name: 'Electricity',
            date: '2021-12-01',
            total: 40.95,
            isPaid: true,
            home: {
                id: 1,
                name: 'Barley Farm'
            }
        },
        {
            id: 8,
            name: 'Gas',
            date: '2021-11-10',
            total: 24.71,
            isPaid: true,
            home: {
                id: 1,
                name: 'Barley Farm'
            }
        },
        {
            id: 9,
            name: 'Internet',
            date: '2021-12-01',
            total: 49.99,
            isPaid: true,
            home: {
                id: 1,
                name: 'Barley Farm'
            }
        },
        {
            id: 10,
            name: 'Electricity',
            date: '2021-11-01',
            total: 23.21,
            isPaid: true,
            home: {
                id: 1,
                name: 'Barley Farm'
            }
        },
    ]

    return (
        <Page title="Bills" icon={ UilBill }>
            <Table size="fullwidth">
                <thead>
                <tr>
                    <th>Date</th>
                    <th>Home</th>
                    <th>Name</th>
                    <th>Total</th>
                    <th>Paid?</th>
                </tr>
                </thead>

                <tbody>
                {
                    bills.map(bill => {
                        return (
                            <tr key={ bill.id }>
                                <td>{ bill.date }</td>
                                <td>
                                    <Link to="#">{ bill.home.name }</Link>
                                </td>
                                <td>{ bill.name }</td>
                                <td>£{ bill.total }</td>
                                <td>{ bill.isPaid ? '✔️' : '❌' }</td>
                            </tr>
                        )
                    })
                }
                </tbody>
            </Table>
        </Page>
    )
}